import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import TextUnderline from '@components/TextUnderline';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';

interface Params {
    href: string;
}

declare module '@stackflow/config' {
    interface Register {
        ExternalShopModal: Params;
    }
}

const ExternalShopModal: ActivityComponentType<'ExternalShopModal'> = () => {
    const { pop } = useFlow();
    return (
        <Modal>
            <ModalContainer>
                <Container align='center'>
                    <TextUnderline>
                        <Text size='display' fontWeight='bold'>
                            행정복지센터점
                        </Text>
                    </TextUnderline>
                    <WarningText size='title-lg'>
                        2km 반경 밖 매장입니다<br/>
                        <span>그래도 주문할까요?</span>
                    </WarningText>
                    <MentText color={colors.gray6}>
                        매장에서 주문 확인 후 주문 취소가 불가합니다.
                    </MentText>
                    <CancelButton fullWidth
                        variant='tone'
                        onClick={pop} >
                        취소
                    </CancelButton>
                    <Button fullWidth>
                        주문하기
                    </Button>
                </Container>
            </ModalContainer>
        </Modal>
    );
};

const Container = styled(Column)`
    padding-top: 24px;
`;

const WarningText = styled(Text)`
    margin: 8px 0 18px;
    text-align: center;

    span {
        color: #CB2B2B;
    }
`;

const MentText = styled(Text)`
    margin-bottom: 20px;
`;

const CancelButton = styled(Button)`
    margin-bottom: 10px;
`;

export default ExternalShopModal;
